import React, { createContext, useContext, useEffect, useState } from 'react'
import { View, Text, TouchableOpacity, Image, Dimensions, StyleSheet, Platform } from 'react-native'
import { ScrollView } from 'react-native'
import Benefits from './src/seeds/benefits.json'
import History from './src/seeds/history.json'
import { FlashList } from '@shopify/flash-list'
import styles from './src/assets/styles'
import BenefitContext from './BenefitContext'
import theme from '../../../theme'
import { useFetchBenefitHistory } from './hooks/useFetchBenefits'
import PostFlags from '../posts/PostFlags'
import { AntDesign } from '@expo/vector-icons'
import { Loader } from '../customUtils/Components/Loader'
import { RefreshControl } from 'react-native-gesture-handler'
import styless from './benefitsHistoryListStyles'
import { getLanguage } from '../appBar/context/LocalizationContext'
import { isIOS, isAndroid } from '../../utils/platformUtils'
import { placeholderGeneral } from '../customUtils/Constants'

const statusBenefits = {
    0: 'Pendiente',
    1: 'Aprobado',
    '-1': 'Cancelado',
}
const isWeb = Platform.OS === 'web'
const BenefitHistoryItem = ({ item }) => {
    const { languageFile } = getLanguage()

    const date = new Date(item?.date)
    const day = date.getDate()
    const month = date.getMonth() + 1
    const year = date.getFullYear()
    const hours = date.getHours()
    const minutes = date.getMinutes().toString().padStart(2, '0')
    const formattedDate = `${day}/${month}/${year} - `
    const formattedHour = `${hours}:${minutes} hs.`
    const status = statusBenefits[item.status]

    const statusColor =
        status === 'Aprobado'
            ? theme.colors.colorApproved
            : status === 'Cancelado'
            ? theme.colors.colorDisapproved
            : status === 'Pendiente'
            ? theme.colors.colorPending
            : theme.colors.darkGray

    const pointsColor =
        status !== 'Aprobado' && status !== 'Cancelado' && status !== 'Pendiente' ? theme.colors.colorApproved : theme.colors.colorDisapproved

    return (
        <View style={[styles.benefitsModule, isWeb && { borderBottomColor: theme.colors.colorPrimary + '33', borderBottomWidth: 1 }]}>
            <Image
                style={[styles.benefitHistoryImage, isWeb && { width: 80, marginRight: 15 }]}
                source={{ uri: item?.image ? item?.image : placeholderGeneral }}
            />
            <View style={styles.benefitHistoryDescriptions}>
                <Text style={[styles.date, isWeb && { fontSize: 16 }]}>
                    {formattedDate}
                    {formattedHour}
                </Text>

                <Text style={[styles.benefitCategoryName, isWeb && { fontSize: 16 }]}>
                    {status ? languageFile.redeemed : languageFile.added_points}
                </Text>
                <Text style={[styles.benefits, isWeb && { fontSize: 16 }]}>{item.name}</Text>
                {status && <Text style={[styles.status, { color: 'white', borderColor: statusColor, backgroundColor: statusColor }]}>{status}</Text>}
            </View>
            <View style={styles.justifyCenter}>
                <Text
                    style={[
                        styles.points,
                        {
                            color: pointsColor,
                        },
                        isWeb && { fontSize: 16 },
                    ]}
                >
                    {status !== 'Aprobado' && status !== 'Cancelado' && status !== 'Pendiente'
                        ? '+ ' + item.points + ' pts'
                        : '- ' + item.points + ' pts'}
                </Text>
            </View>
        </View>
    )
}

const BenefitsHistoryList = ({ dataRedeems }) => {
    const { points, dataPoints, isLoading, reload, fetch_data, setIsLoading } = useFetchBenefitHistory()
    const [refresing, setRefresing] = useState(false)
    const { languageFile } = getLanguage()

    let origin_labels = [
        { _id: 1, name: languageFile.all, status: 10, isSelected: true },
        { _id: 2, name: languageFile.my_points, status: 11 },
        { _id: 4, name: languageFile.pending, status: 0 },
        { _id: 5, name: languageFile.approved, status: 1 },
        { _id: 6, name: languageFile.delivered, status: 2 },
        { _id: 7, name: languageFile.cancelled, status: -1 },
    ]
    const [labels, setLabels] = useState(origin_labels)
    const [selectedLabel, setSelectedLabel] = useState(1)
    const [redeems, setRedeems] = useState([])
    const [goBack, setGoBack] = useState(false)

    const onRefresh = async () => {
        setRefresing(true)
        await fetch_data().then((data) => {
            console.log('cierro pull refresh')
            setRefresing(false)
        })
    }

    const handleSelectLabel = (labelId) => {
        console.log('🚀 ~ handleSelectLabel ~ labelId:', labelId)
        let label_selected = origin_labels.find((item) => item._id === labelId)
        console.log(labelId, '🚀7777777777 ~ postion ~ label_selected:', label_selected)

        let newData
        let all = [...dataPoints, ...dataRedeems]
        if (label_selected['status'] == 10) {
            all.sort((a, b) => {
                const dateA = new Date(a.date)
                const dateB = new Date(b.date)
                return dateB - dateA
            })
            newData = all
            setLabels(origin_labels)
            setGoBack(false)
        } else {
            if (label_selected['status'] == 11) {
                newData = dataPoints
            } else {
                newData = dataRedeems.filter((item) => item.status == label_selected.status)
                console.log('🚀 ~ handleSelectLabel ~ newData:', newData.length)
            }
        }
        setSelectedLabel(labelId)
        setLabels((prevLabels) =>
            prevLabels.map((label) => ({
                ...label,
                isSelected: label._id === labelId,
            })),
        )
        setRedeems(newData)
    }

    useEffect(() => {
        handleSelectLabel(selectedLabel)
    }, [dataPoints, dataRedeems])

    return isLoading ? (
        <>
            <View style={{ height: 20 }} />
            <Loader />
        </>
    ) : (
        <>
            <View style={[styles.viewLabels, isWeb && { marginTop: 15, marginBottom: 15 }]}>
                <ScrollView horizontal={true} showsHorizontalScrollIndicator={false} style={styless.scrollView}>
                    <FlashList
                        data={labels}
                        keyExtractor={(item, index) => index.toString()}
                        horizontal={true}
                        showsHorizontalScrollIndicator={false}
                        renderItem={({ item: post }) => (
                            <PostFlags posts={post} onSelectLabel={handleSelectLabel} extraStyle={{ borderRadius: 20 }} />
                        )}
                    />
                </ScrollView>
            </View>

            {redeems.length == 0 ? (
                <View style={styless.container}>
                    <View style={styles.spacer}></View>
                    <Image style={styless.image} source={require('../../../assets/noBenefitsHistory.png')} />
                    <Text style={styless.title}>{languageFile.no_history}</Text>
                    <Text style={styless.description}>{languageFile.redeem_your_points}</Text>
                </View>
            ) : (
                <FlashList
                    refreshControl={<RefreshControl refreshing={refresing} onRefresh={onRefresh} progressViewOffset={10} />}
                    data={redeems}
                    horizontal={false}
                    keyExtractor={(item) => item._id.toString()}
                    numColumns={1}
                    showsHorizontalScrollIndicator={false}
                    showsVerticalScrollIndicator={false}
                    renderItem={({ item: benefitItem }) => <BenefitHistoryItem item={benefitItem} />}
                />
            )}
        </>
    )
}

export default BenefitsHistoryList
